import { type FC } from 'react'

import { Link } from 'base-ui'

import { type AlgoliaRecord } from '../../../algolia'
import { urlGetRelativeUrl } from '../../../url-handling'

import { StoryblokProductBatteryLink } from './StoryblokProductBatteryLink'

type Props = {
  product: AlgoliaRecord
}

export const StoryblokProductBatteryName: FC<Props> = ({ product }) => {
  return (
    <Link
      className="line-clamp-3 overflow-hidden text-ellipsis font-medium text-dark-primary-max no-underline"
      data-analytics="item-title"
      data-qa-id={`form-product-slider-${product.objectID}-link-button`}
      href={urlGetRelativeUrl(product.deeplink)}
      slots={{ root: StoryblokProductBatteryLink }}
      title={product.productName}
    >
      {product.productName}
    </Link>
  )
}
